const dev = {
  env: 'development',
  api: {
    TRAVEL_URL: "//localhost:5000",
    DOMAIN: "localhost"
  },
};

const beta = {
  env: 'beta',
  api: {
    TRAVEL_URL: "https://api2.travelities.com",
    DOMAIN: "beta.travelities.com"
  },
};

const prod = {
  env: 'production',
  api: {
    TRAVEL_URL: "https://api.travelities.com",
    DOMAIN: ".travelities.com"
  },
};

export const config = process.env.REACT_APP_STAGE === 'production' ? prod : process.env.REACT_APP_STAGE === 'beta' ? beta : dev;